<fui-inline-fascia (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()"
                   [hovered]="hovered">
    <fui-fixtures>
        @if (!disabled) {
            <fui-fixture>
                <fui-mark-toggle [toggled]="popped">
                    <fui-icon [height]="12" [icon]="'chevron-down'" [width]="12"></fui-icon>
                </fui-mark-toggle>
            </fui-fixture>
        }
        @if (showImage) {
            <fui-spanning-fixture>
                <fui-input-dom>
                    <fui-image class="image" #input
                               [tabindex]="tabindex" (blur)="onBlur($event)" (focus)="onFocus($event)"
                               [imageBase64]="value || placeholderImage" [imageOpacity]="imageOpacity"
                               [allowSvg]="allowSvg">
                    </fui-image>
                </fui-input-dom>
            </fui-spanning-fixture>
        }
        @if (!showImage && showOpacitySlider) {
            <fui-spanning-fixture>
                <fui-input-dom>
                    {{ imageOpacity }}
                </fui-input-dom>
            </fui-spanning-fixture>
        }
        @if (showImage) {
            <fui-action-fixture class="actions">
                <fui-action class="actions-action" (click)="clear($event)" [disabled]="!value">
                    <fui-icon [height]="15" [width]="15" [icon]="'delete'"></fui-icon>
                </fui-action>
            </fui-action-fixture>
        }
        @if (validateable) {
            <fui-fixture>
                <fui-validations [control]="control" [focussed]="focussed"></fui-validations>
            </fui-fixture>
        }
    </fui-fixtures>
</fui-inline-fascia>
<fui-image-pop [popped]="popped" (popped$)="pop($event)">
    <fui-edit-image-input [(ngModel)]="value" [(imageOpacity)]="imageOpacity"
                          [label]="label" [placeholder]="placeholder"
                          [maxImageSize]="maxImageSize" [allowSvg]="allowSvg"
                          [showImage]="showImage" [showOpacitySlider]="showOpacitySlider">
    </fui-edit-image-input>
</fui-image-pop>
